/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Shot_ChatInputs */

const en_mk_shot_chat = /** @type {(inputs: Mk_Shot_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Dapur Nusa team’s promo-mingguan channel, with a campaign brief, an @Kira mention, and a link to the agent’s reply.`)
};

const id_mk_shot_chat = /** @type {(inputs: Mk_Shot_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Channel promo-mingguan tim Dapur Nusa dengan brief kampanye, mention @Kira, dan tautan ke balasan agen.`)
};

/**
* | output |
* | --- |
* | "The Dapur Nusa team’s promo-mingguan channel, with a campaign brief, an @Kira mention, and a link to the agent’s reply." |
*
* @param {Mk_Shot_ChatInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_shot_chat = /** @type {((inputs?: Mk_Shot_ChatInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Shot_ChatInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_shot_chat(inputs)
	return en_mk_shot_chat(inputs)
});